import { PrimaryColors, TextColors } from '@/utils/constants';
import { makeStyles } from '@material-ui/core/styles';

const useNotificationStyles = makeStyles(
  (muiTheme) => ({
    notificationHeader: {
      display: 'grid',
      gridTemplateColumns: '50% 50%',
      padding: muiTheme.spacing(3, 4, 1, 4),
      '& div:nth-child(2)': {
        textAlign: 'right',
      },
      '& .notification-heading': {
        fontSize: '18px',
      },
      '& .notification-mark-as-read': {
        fontSize: '12px',
        textDecoration: 'underline',
        padding: 0,
      },
    },
    emptyNotification: {
      padding: muiTheme.spacing(6, 2),
      textAlign: 'center',
    },
    notificationList: {
      '& .notification:hover': {
        '& .divider': {
          borderTop: '1px solid transparent',
        },
        borderTop: `1px solid ${PrimaryColors.light}`,
        marginTop: '-1px',
        position: 'relative',
      },
      '& .notification .divider': {
        width: 'calc(100% - 64px)',
        height: 0,
        display: 'block',
        margin: 'auto',
        position: 'relative',
        borderTop: `1px solid ${TextColors.dark}`,
      },
      '& .notification:last-child .divider': {
        borderTop: '1px solid transparent',
      },
    },
    infoMobile: {
      display: 'flex',
      gap: '8px',
    },
  }),
  { name: 'Notifications' },
);

export default useNotificationStyles;
